import { render } from "./OrderData.vue?vue&type=template&id=396c7474&scoped=true"
import script from "./OrderData.vue?vue&type=script&lang=js"
export * from "./OrderData.vue?vue&type=script&lang=js"

import "./OrderData.vue?vue&type=style&index=0&id=396c7474&lang=css&scoped=true"

import exportComponent from "/Users/lucas/Documents/repo/tiototo-users-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396c7474"]])

export default __exports__